import { Divider, Avatar, Typography, Box, Stack } from '@mui/material';
import { getInitials } from '@/utils/getInitials';

export const NoteReporterBar = ({ name, editMode, isNewThread }: { name: string; editMode?: boolean; isNewThread?: boolean }) => {
  return (
    <Stack sx={{ background: 'white', width: '100%' }}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={2}
        sx={{
          width: '100%',
          paddingY: isNewThread || editMode ? '11px' : 0,
          paddingX: isNewThread || editMode ? '18px' : 0,
          pb: isNewThread || editMode ? undefined : '11px',
        }}
      >
        {isNewThread && (
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '24px',
              color: '#344054',
            }}
          >
            Reporter:
          </Typography>
        )}
        <Avatar
          sx={{
            // height: '40px',
            // width: '40px',
            height: '26px',
            width: '26px',
            bgcolor: '#2055ff',
            color: 'white',
            border: '1px solid #D1D1D1',
            fontSize: '14px',
          }}
        >
          {getInitials(name || 'Guest')}
        </Avatar>
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '16px',
            color: 'black',
          }}
        >
          {name || 'Guest'}
        </Typography>
      </Box>
      <Divider />
    </Stack>
  );
};
